import $ from 'jquery';

class MaRSVenues{

  constructor() {
    this.filterSelect = $(".venuesSection__filter select");
    this.locationFilter = $(".locations-selection");
    this.minCapacityFilter = $(".capacity-min-selection");
    this.maxCapacityFilter = $(".capacity-max-selection");
    this.eventTypeFilter = $(".event-type-selection");
    this.setupTypeFilter = $(".setup-type-selection");
    this.selectedFilters = {};
    setTimeout(this.LoadActiveResults(), 750);
    this.resultsDiv = $(".venuesSection__results");
    this.loadMoreButton = $(".venuesSection__load a");
    this.events();
    this.isSpinnerVisible = false;
    this.loadInfo;
  }

  events() {
    this.loadMoreButton.on("click", this.getMoreResults.bind(this));
    // filter triggers
    this.locationFilter.on("click",     this.debounce(this.generateSelectedFilters.bind(this), 500));
    this.minCapacityFilter.on("change", this.debounce(this.generateSelectedFilters.bind(this), 500));
    this.maxCapacityFilter.on("change", this.debounce(this.generateSelectedFilters.bind(this), 500));
    this.eventTypeFilter.on("click",    this.debounce(this.generateSelectedFilters.bind(this), 500));
    this.setupTypeFilter.on("click",    this.debounce(this.generateSelectedFilters.bind(this), 500));
  }


  debounce(func, delay) {
    let timeoutId;
    return function(...args) {
      const context = this;
      if (timeoutId) {
        clearTimeout(timeoutId);
      }
      timeoutId = setTimeout(() => {
        func.apply(context, args);
      }, delay);
    };
  }

  generateSelectedFilters(e) {
    // format selected filters object
    let selectedValues = [];

    if(e.currentTarget.classList.contains('locations-selection')) {
      selectedValues = [];
      $('.locations-selection:checked').each(function() {
        selectedValues.push($(this).val());
      });
      this.selectedFilters.location = selectedValues;
    } else if(e.currentTarget.classList.contains('capacity-min-selection')) {
      this.selectedFilters.minCapacity = $(e.currentTarget).val();
      $('#capacity span').html('('+(this.selectedFilters.minCapacity || 1)+'-'+(this.selectedFilters.maxCapacity || 500)+')');
    } else if(e.currentTarget.classList.contains('capacity-max-selection')) {
      this.selectedFilters.maxCapacity = $(e.currentTarget).val();
      $('#capacity span').html('('+(this.selectedFilters.minCapacity || 1)+'-'+(this.selectedFilters.maxCapacity || 500)+')');
    } else if(e.currentTarget.classList.contains('event-type-selection')) {
      selectedValues = [];
      $('.event-type-selection:checked').each(function() {
        selectedValues.push($(this).val());
      });
      this.selectedFilters.eventType = selectedValues;
    } else if(e.currentTarget.classList.contains('setup-type-selection')) {
      selectedValues = [];
      $('.setup-type-selection:checked').each(function() {
        selectedValues.push($(this).val());
      });
      this.selectedFilters.setupType = selectedValues;
    }
    this.LoadActiveResults(this.selectedFilters);
  }

  LoadActiveResults( selectedFilters = {}) {
    let eventType = selectedFilters?.eventType || '';
    let location = selectedFilters?.location || '';
    let maxCapacity = selectedFilters?.maxCapacity || '';
    let minCapacity = selectedFilters?.minCapacity || '';
    let setupType = selectedFilters?.setupType || '';
    let vm = this;

    if ($(".venuesSection__results").length) {

      if (!vm?.isSpinnerVisible) {
        vm?.resultsDiv?.html(`
          <div class="col col-12 sk-double-bounce-wrapper">
            <div class="sk-double-bounce">
              <div class="sk-child sk-double-bounce1"></div>
              <div class="sk-child sk-double-bounce2"></div>
            </div>
          </div>`);
          vm.isSpinnerVisible = true;
      }
  
      $.getJSON(MaRS_DATA.site_url + `/wp-json/mars/v1/venues?number=12&location=${location}&capacity=${minCapacity || ''}-${maxCapacity || ''}&event_type=${eventType}&setup_type=${setupType}&page=1`, (results) => {
        let currentPage = results.current_page;
        vm?.resultsDiv?.html(`
          ${results?.venueInfo?.length ? '' : '<div class="col col-12 my-4 text-center"><p>No venues matched your search.</p></div>'}
          ${results?.venueInfo?.map(item => `
            <div class="col col-12 col-md-6 col-lg-4 mb-4">
              <div class="venuesSection__venueCard">
                <a href="${item?.permalink}" class="venueCard__link">
                  <div class="venuesSection__venueCard--image">
                    <img src="${item.thumbnail_image ?? '/wp-content/themes/marsdd-chapter/assets/img/placeholder.png'}" alt="${item.title} featured image" />
                  </div>
                  <div class="venuesSection__venueCard--content">
                    <h3 class="venueCard__title">${item?.title}</h3>
                    ${item.room_details.location_name ? `<p class="venueCard__location">${item.room_details.location_name}</p>` : ''}
                    ${item.room_details.location_address.address ? `<p class="venueCard__address">
                    ${item.room_details.location_address.address}<br />
                    ${item.room_details.location_address.city}, 
                    ${item.room_details.location_address.province}, 
                    ${item.room_details.location_address.postal_code}</p>` : ''}
                  </div>
                </a>
              </div>
            </div>
          `).join('')}
        `);

        $('.sk-double-bounce-wrapper').remove();
        vm.isSpinnerVisible = false;
        vm?.loadMoreButton.attr("data-url", `number=12&location=${location || ''}&capacity=${minCapacity || ''}-${maxCapacity || ''}&event_type=${eventType || ''}&setup_type=${setupType || ''}&page=${parseInt(currentPage) + 1}`);
        `${(results?.max_pages == currentPage || results?.max_pages == 0) ? vm?.loadMoreButton.hide() : vm?.loadMoreButton.show()}`;
      }).fail(function (jqXHR, textStatus, error) {
        console.error("getMoreResults: ", textStatus, error);
      });
    }
  }


  getMoreResults(e) {
    e.preventDefault();
    this.loadInfo = this.loadMoreButton.attr("data-url");
    let vm = this;

    if (!vm?.isSpinnerVisible) {
      vm?.resultsDiv?.append(`
        <div class="col col-12 sk-double-bounce-wrapper">
          <div class="sk-double-bounce">
            <div class="sk-child sk-double-bounce1"></div>
            <div class="sk-child sk-double-bounce2"></div>
          </div>
        </div>`);
      vm.isSpinnerVisible = true;
    }

    $.getJSON(MaRS_DATA.site_url + '/wp-json/mars/v1/venues?' + vm.loadInfo, (results) => {
      let currentPage = results.current_page;
      vm.resultsDiv.append(`
        ${results.venueInfo.length ? '' : '<div class="col col-12 my-4 text-center"><p>No more venues matched your search.</p></div>'}
        ${results.venueInfo.map(item => `
          <div class="col col-12 col-md-6 col-lg-4 mb-4">
            <div class="venuesSection__venueCard">
              <a href="${item.permalink}" class="venueCard__link">
                <div class="venuesSection__venueCard--image">
                  <img src="${item.thumbnail_image ?? '/wp-content/themes/marsdd-chapter/assets/img/placeholder.png'}" alt="${item.title} featured image" />
                </div>
                <div class="venuesSection__venueCard--content">
                  <h3 class="venueCard__title">${item.title}</h3>
                    ${item.room_details.location_name ? `<p class="venueCard__location">${item.room_details.location_name}</p>` : ''}
                    ${item.room_details.location_address.address ? `<p class="venueCard__address">
                    ${item.room_details.location_address.address}<br />
                    ${item.room_details.location_address.city}, 
                    ${item.room_details.location_address.province}, 
                    ${item.room_details.location_address.postal_code}</p>` : ''}
                </div>
              </a>
            </div>
          </div>
        `).join('')}
      `);
      $('.sk-double-bounce-wrapper').remove();
      vm.isSpinnerVisible = false;
      vm.loadMoreButton.attr("data-url", `number=12&location=${vm.selectedFilters.location || ''}&capacity=${vm.selectedFilters.minCapacity || ''}-${vm.selectedFilters.maxCapacity || ''}&event_type=${vm.selectedFilters.eventType || ''}&setup_type=${vm.selectedFilters.setupType || ''}&page=${parseInt(currentPage) + 1}`);
      `${results.max_pages == currentPage ? vm.loadMoreButton.hide() : vm.loadMoreButton.show()}`;
    }).fail(function(jqXHR, textStatus, error) {
      console.error("getMoreResults: ", textStatus, error);
    });
  }
}

export default MaRSVenues;